module.exports = __webpack_public_path__ + "img/anuenciaConsCell.87af7c62.jpg";